/**
 * Digits-only phone normalizer. The TS function and the SQL twin
 * (`PHONE_DIGITS_SQL`) must agree: both strip every non-ASCII-digit character.
 * Pure and browser-safe (imported by the frontend via `@shared`).
 */
export function normalizePhoneDigits(input: string | null | undefined): string {
  if (!input) return '';
  return input.replace(/[^0-9]/g, '');
}

/** SQL expression twin of `normalizePhoneDigits` for a column reference. */
export function PHONE_DIGITS_SQL(col: string): string {
  return `regexp_replace(COALESCE(${col}, ''), '\\D', '', 'g')`;
}

/** Trimmed string, or null when blank/absent. */
export function nonEmpty(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}
